import React, { useCallback, useContext, useEffect, useState } from 'react';

import { DashboardContext, FilterBar } from '@acoer/ac-js-lib-charts';
import Sticky from 'react-sticky-el';
import {
    activityFilters,
    activityBetaFilters,
} from '../../../../Audit/dashboards/Activities/filters';
import { ThemeProvider } from '@mui/styles';
import { AppContext } from '../../../../../containers/AppProviderWrapper';
import SaveTemplateDialog from './SaveTemplateDialog';
import { useTheme } from '@mui/material';

//redux
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../DashboardActions';
import * as confirmActions from '../../../../Confirmation/ConfirmationActions';
import { workspaceActions } from '../../../WorkspaceActions';
import ManageTemplateDialog from './ManageTemplateDialog';

const Filters = ({ type, area, filterType, allowFilterTemplates }) => {
    const { currentUser } = useContext(AppContext);
    const [filterDefinitions, setFilterDefinitions] = useState([]);
    const [openSaveTemplateDialog, setOpenSaveTemplateDialog] =
        useState<boolean>(false);
    const [openManageTemplateDialog, setOpenManageTemplateDialog] =
        useState<boolean>(false);
    const filterValues = useSelector(
        (state: any) => state.dashboard.filters || {}
    );
    const savedFilters = useSelector(
        (state: any) =>
            (state.dashboard.filter && state.dashboard.filter.data) || {}
    );
    const savedFilterConfiguration = useSelector(
        (state: any) =>
            state.workspace && state.workspace['saved-filters-configuration']
    );
    const areaConfigs = useSelector((state: any) => state.areaConfigs);
    const dispatch = useDispatch();
    const theme = useTheme();

    useEffect(() => {
        if (
            type !== 'activity' &&
            areaConfigs &&
            areaConfigs[area] &&
            areaConfigs[area]['dashboard-configuration'] &&
            areaConfigs[area]['dashboard-configuration'].filters
        ) {
            const filters =
                areaConfigs[area]['dashboard-configuration'].filters;
            setFilterDefinitions(filters);
        } else if (type === 'activity') {
            if (
                currentUser &&
                currentUser.userConfiguration &&
                currentUser.userConfiguration.beta
            ) {
                setFilterDefinitions(activityBetaFilters as any);
            } else {
                setFilterDefinitions(activityFilters as any);
            }
        }
    }, [area, type, areaConfigs, currentUser]);

    const getFilterValues = useCallback(
        (
            value: string,
            filterId: string | undefined,
            isTypeahead: boolean | undefined
        ) => {
            dispatch(
                actions.getFilterValues(
                    type.toUpperCase(),
                    area,
                    value,
                    filterId,
                    isTypeahead
                )
            );
        },
        [dispatch, type, area]
    );

    const handleRemoveFilter = useCallback(
        (id: string) => {
            const newFilters = { ...savedFilters };
            delete newFilters[id];
            dispatch(
                confirmActions.showConfirmation(
                    'Confirm',
                    'Are you sure you want to remove this filter?',
                    'removeFilter',
                    newFilters
                )
            );
        },
        [dispatch, savedFilters]
    );

    const setFilters = useCallback(
        (filters: any) => {
            dispatch(actions.setFilters(filters));
        },
        [dispatch]
    );

    const handleClearFilter = useCallback(() => {
        dispatch(
            confirmActions.showConfirmation(
                'Confirm',
                'Are you sure you want to clear all filters?',
                'removeFilter',
                {}
            )
        );
    }, [dispatch]);

    const handleSaveTemplate = (value: string) => {
        let config = [];
        if (savedFilterConfiguration && savedFilterConfiguration.length) {
            config = [
                ...savedFilterConfiguration,
                {
                    name: value,
                    filters: savedFilters,
                },
            ];
        } else {
            config = [
                {
                    name: value,
                    filters: savedFilters,
                },
            ];
        }

        dispatch(
            workspaceActions?.setWorkspaceConfiguration(
                area,
                'saved-filters-configuration',
                config
            )
        );
    };

    return (
        <>
            <DashboardContext.Provider
                value={{
                    type,
                    filters: filterDefinitions,
                }}
            >
                <ThemeProvider theme={theme}>
                    <div
                        style={{
                            float: filterType === 'simple' ? 'right' : null,
                        }}
                    >
                        <Sticky stickyStyle={{ zIndex: 1040 }}>
                            <FilterBar
                                filterValues={filterValues}
                                savedFilters={savedFilters}
                                getFilterValues={getFilterValues}
                                onHandleRemoveFilter={handleRemoveFilter}
                                onClearFilter={handleClearFilter}
                                setFilters={setFilters}
                                // @ts-ignore
                                mode={theme.palette.mode}
                                theme={theme}
                                filterBarType={filterType}
                                saveTemplate={() =>
                                    setOpenSaveTemplateDialog(true)
                                }
                                updateTemplate={() =>
                                    setOpenManageTemplateDialog(true)
                                }
                                savedTemplates={savedFilterConfiguration}
                                allowFilterTemplates={allowFilterTemplates}
                            />
                        </Sticky>
                    </div>
                </ThemeProvider>
            </DashboardContext.Provider>
            <SaveTemplateDialog
                open={openSaveTemplateDialog}
                handleClose={() => setOpenSaveTemplateDialog(false)}
                saveTemplate={handleSaveTemplate}
            />
            <ManageTemplateDialog
                open={openManageTemplateDialog}
                handleClose={() => setOpenManageTemplateDialog(false)}
                area={area}
            />
        </>
    );
};

export default Filters;
